import { siteversion } from '@envs/version';

const envLocal = {
  version: siteversion.version,
  kcUrl: 'https://cloudia2-customer-staging.tcpdev.com/auth',
  kcRealm: {
    cloudia: 'cloudia-test',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia2-customer-test.tcpdev.com/api/',
  production: false,
  localBackend: false,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbzlxaafncf5nuG58NbYCaecrWibAh8hJkgbVLJMtJTr/dev',
  env: 'TEST',
  tenant: 'cloudia',
  useGoogleAnalytics: false,
  analyticsTrackingId: '',
  useHotJar: false,
  hotjarId: 0,
};

const envTest = {
  version: siteversion.version,
  kcUrl: 'https://cloudia2-customer-staging.tcpdev.com/auth',
  kcRealm: {
    cloudia: 'cloudia-test',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia2-customer-test.tcpdev.com/api/',
  production: false,
  localBackend: false,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbzlxaafncf5nuG58NbYCaecrWibAh8hJkgbVLJMtJTr/dev',
  env: 'TEST',
  tenant: 'cloudia',
  useGoogleAnalytics: true,
  analyticsTrackingId: 'GTM-WBZ5H5F4',
  useHotJar: true,
  hotjarId: 3636711,
};

const envStaging = {
  version: siteversion.version,
  kcUrl: 'https://cloudia2-customer-staging.tcpdev.com/auth',
  kcRealm: {
    cloudia: 'cloudia-staging',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia2-customer-staging.tcpdev.com/api/',
  production: false,
  localBackend: false,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbzlxaafncf5nuG58NbYCaecrWibAh8hJkgbVLJMtJTr/dev',
  env: 'STAGING',
  tenant: 'cloudia',
  useGoogleAnalytics: true,
  analyticsTrackingId: 'GTM-N23RSQSM',
  useHotJar: true,
  hotjarId: 3636709,
};

const envDemo = {
  version: siteversion.version,
  kcUrl: 'https://cloudia2-customer-staging.tcpdev.com/auth',
  kcRealm: {
    cloudia: 'cloudia-demo',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia2-customer-demo.tcpdev.com/api/',
  production: false,
  localBackend: false,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbzlxaafncf5nuG58NbYCaecrWibAh8hJkgbVLJMtJTr/dev',
  env: 'DEMO',
  tenant: 'cloudia',
  useGoogleAnalytics: false,
  analyticsTrackingId: 'GTM-N23RSQSM',
  useHotJar: false,
  hotjarId: 3636709,
};

const envProd = {
  version: siteversion.version,
  kcUrl: 'https://customer.thecloudpeople.com/auth/',
  kcRealm: {
    cloudia: 'cloudia',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://customer.thecloudpeople.com/api/',
  production: true,
  localBackend: false,
  env: 'PROD',
  tenant: 'cloudia',
  useGoogleAnalytics: true,
  analyticsTrackingId: 'GTM-NMLNFSSX',
  useHotJar: true,
  hotjarId: 3636704,
};

export const environment = getEnvs();

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function getEnvs() {
  // eslint-disable-next-line
  let envName = window["env"].env_name;
  if (envName === 'prod') {
    return envProd;
  }
  if (envName === 'staging') {
    return envStaging;
  }
  if (envName === 'local') {
    return envLocal;
  }
  if (envName === 'demo') {
    return envDemo;
  }
  return envTest;
}
